/*
This action file conatin the action related to profile update,add,edit member etc 
*/
import * as api from '../api/profileEdit';

export const EDIT_PROFILE_REQUEST='EDIT_PROFILE_REQUEST';
export const EDIT_PROFILE_REQUEST_SUCCESS='EDIT_PROFILE_REQUEST_SUCCESS';
export const EDIT_PROFILE_REQUEST_FAIL='EDIT_PROFILE_REQUEST_FAIL';
export const NOTIFICATION_ADD = 'NOTIFICATION_ADD';

export function editProfileSave(formdata,image,name,type,email,currentEmail,userId,compId){
	return function(dispatch, getState){
	    dispatch({
	      type: EDIT_PROFILE_REQUEST
	    });
	    api.editProfilePic(formdata,userId,compId).then(
	    	(response) => {
	    		dispatch({
		          type: 'EDIT_PROFILE_PIC_REQUEST_SUCCESS',
		          profileupdate: response
		        });
		     //    dispatch({
		     //      type: NOTIFICATION_ADD,
		     //      text: 'Profile image uploaded successfully',
		     //      msgtype: 'success'
		     //    });
	    		api.editProfileSave(image,name,type,email,currentEmail).then(
			    	(response) => {
				        dispatch({
				          type: EDIT_PROFILE_REQUEST_SUCCESS,
				          profileupdate: response
				        });
				        dispatch({
				          type: NOTIFICATION_ADD,
				          text: 'Profile edited successfully.',
				          msgtype: 'success'
				        });
				      },
				      (error) => {
				        dispatch({
				          type: EDIT_PROFILE_REQUEST_FAIL,
				          error: error,
				          message: error.message || 'Could not complete edit profile request.'
				        });
				        dispatch({
				          type: NOTIFICATION_ADD,
				          text: error.message || 'Could not complete edit profile request.',
				          msgtype: 'danger'
				        });
				      }
			    );
	    	},
	    	(error) => {
	    		dispatch({
		          type: EDIT_PROFILE_REQUEST_FAIL,
				          error: error,
				          message: error.message || 'Could not complete edit profile request, profile pic not uploaded.'
		        });
		        dispatch({
		          type: NOTIFICATION_ADD,
		          text: error.message || 'Could not complete edit profile request, profile pic not uploaded',
		          msgtype: 'danger'
		        });
	    	}
	    );
	    
	};
}

export function unsetProfileeditFlag(){
	return function(dispatch, getState){
		dispatch({
	      type: 'Unset Profile Edit Flag',
	    });
	 };
}
export function unsetAddEditMemberFlag(){
	return function(dispatch, getState){
		dispatch({
	      type: 'Unset Profile Edit Flag',
	    });
	 };
}

export const EDIT_PASS_REQUEST='EDIT_PASS_REQUEST';
export const EDIT_PASS_SUCCESS='EDIT_PASS_SUCCESS';
export const EDIT_PASS_FAIL='EDIT_PASS_FAIL';

export function updatePassword(email,oldpass,newpass){
	return function(dispatch, getState){
	    dispatch({
	      type: EDIT_PASS_REQUEST
	    });
		api.updatePassword(email,oldpass,newpass).then(
	    	(response) => {
		        dispatch({
		          type: EDIT_PASS_SUCCESS,
		          payment: response
		        });
		        dispatch({
		          type: NOTIFICATION_ADD,
		          text: 'Password updated Successfully.',
		          msgtype: 'success'
		        });
		      },
		      (error) => {
		        dispatch({
		          type: EDIT_PASS_FAIL,
		          error: error,
		          message: error.message || 'Could not complete edit password request.'
		        });
		        dispatch({
		          type: NOTIFICATION_ADD,
		          text: error.message || 'Please enter the correct old password!.',
		          msgtype: 'danger'
		        });
		      }
	    );	    
	};
}

export const CHECk_PASS_REQUEST='CHECk_PASS_REQUEST';
export const CHECK_PASS_SUCCESS='CHECK_PASS_SUCCESS';
export const CHECK_PASS_FAIL='CHECK_PASS_FAIL';

export function checkOldPassword(email,oldpass){
	return function(dispatch, getState){
	    dispatch({
	      type: CHECk_PASS_REQUEST
	    });
		api.checkOldPassword(email,oldpass).then(
	    	(response) => {
		        dispatch({
		          type: CHECK_PASS_SUCCESS,
		          payment: response
		        });
		      },
		      (error) => {
		        dispatch({
		          type: CHECK_PASS_FAIL,
		          error: error,
		          message: error.message || 'Could not complete check password request.'
		        });
		      }
	    );	    
	};
}

export const EDIT_MEMBER_REQUEST='EDIT_MEMBER_REQUEST';
export const EDIT_MEMBER_REQUEST_SUCCESS='EDIT_MEMBER_REQUEST_SUCCESS';
export const EDIT_MEMBER_REQUEST_FAIL='EDIT_MEMBER_REQUEST_FAIL';

export function editMemberSave(name,type,email,id){
	return function(dispatch, getState){
	    dispatch({
	      type: EDIT_MEMBER_REQUEST
	    });
		api.editMemberSave(name,type,email,id).then(
	    	(response) => {
		        dispatch({
		          type: EDIT_MEMBER_REQUEST_SUCCESS,
		          profileupdate: response
		        });
		        dispatch({
		          type: 'Add Edit Delete TeamMember',
		        });
		        dispatch({
		          type: NOTIFICATION_ADD,
		          text: 'Team Member updated Successfully.',
		          msgtype: 'success'
		        });
		      },
		      (error) => {
		        dispatch({
		          type: EDIT_MEMBER_REQUEST_FAIL,
		          error: error,
		          message: error.message || 'Could not complete edit member request.'
		        });
		        dispatch({
		          type: NOTIFICATION_ADD,
		          text: 'Could not complete edit member request.',
		          msgtype: 'danger'
		        });
		      }
	    );    
	};
}

export const ADD_TEAM_MEMBER_REQUEST='ADD_TEAM_MEMBER_REQUEST';
export const ADD_TEAM_MEMBER_REQUEST_FAIL='ADD_TEAM_MEMBER_REQUEST_FAIL';
export const ADD_TEAM_MEMBER_REQUEST_SUCCESS='ADD_TEAM_MEMBER_REQUEST_SUCCESS';

export function addMemberSave(name,type,email,id, companyId){
	return function(dispatch, getState){
	    dispatch({
	      type: ADD_TEAM_MEMBER_REQUEST
	    });
	    api.addMemberSave(name,type,email,id,companyId).then(
	    	(response) => {
		        dispatch({
		          type: ADD_TEAM_MEMBER_REQUEST_SUCCESS,
		          team: response
		        });
		        dispatch({
		          type: 'Add Edit Delete TeamMember',
		        });
		        dispatch({
		          type: NOTIFICATION_ADD,
		          text: 'Team member added successfully.',
		          msgtype: 'success'
		        });
		      },
		      (error) => {
		      	error.then((errorData) => {
		      		if(errorData.error && errorData.error.code && errorData.error.code === 11000){
		      			dispatch({
				          type: NOTIFICATION_ADD,
				          text: 'Account already exist with this email address.',
				          msgtype: 'danger'
				        });	
		      		}else{
		      			throw error
		      		}
		      		
		      	}).catch(() => {
		      		 dispatch({
			          type: ADD_TEAM_MEMBER_REQUEST_FAIL,
			          error: error,
			          message: error.message || 'Could not create teams.'
			        });
			        dispatch({
			          type: NOTIFICATION_ADD,
			          text: 'Could not complete add member request.',
			          msgtype: 'danger'
			        });
		      	})
		       
		      }
	    );
	};
};




// WEBPACK FOOTER //
// ./src/Actions/profile.js